import axios from "axios";
import {
    GET_USER_CERTS,
    GET_USER_DEGREES,
    GET_USER_EXPERIENCE,
    GET_USER_INFO,
    GET_PDF,
    GET_OR_CREATE_USER,
    GET_USER_PROJECTS,
    GET_USER_SKILLS,
    UPDATE_USER_ACK,
    UPDATE_USER_INFO, GET_USER_PREVIEW, USER_DASHBOARD
} from "./RestCatalog";

const getPdf = (email) => {
    return axios.get(GET_PDF + email)
        .then((response) => response)
        .catch((e) => console.error(e));
};

const getOrCreateUser = (payload) => {
    return axios.post(GET_OR_CREATE_USER, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserInformation = (email) => {
    return axios.get(GET_USER_INFO + email) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const updateUserInformation = (payload) => {
    return axios.post(UPDATE_USER_INFO, payload) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const updateUserAck = (payload) => {
    return axios.post(UPDATE_USER_ACK, payload) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserCerts = (id) => {
    return axios.get(GET_USER_CERTS.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserDegrees = (id) => {
    return axios.get(GET_USER_DEGREES.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserExperience = (id) => {
    return axios.get(GET_USER_EXPERIENCE.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserProjects = (id) => {
    return axios.get(GET_USER_PROJECTS.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserSkills = (id) => {
    return axios.get(GET_USER_SKILLS.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserPreview = (id) => {
    return axios.get(GET_USER_PREVIEW.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUserDashboard = (id) => {
    return axios.get(USER_DASHBOARD.replace('{id}', id)) // todo use construct here
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

export {
    getPdf,
    getOrCreateUser,
    getUserInformation,
    updateUserInformation,
    updateUserAck,
    getUserCerts,
    getUserDegrees,
    getUserExperience,
    getUserProjects,
    getUserSkills,
    getUserPreview,
    getUserDashboard,
};